import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const SubscribeSuccessPage = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login", { replace: true });
      return;
    }
    navigate(user?.userType === "market" ? "/market-dashboard" : "/dashboard", { replace: true });
  }, [isAuthenticated, navigate, user]);

  return null;
};

export default SubscribeSuccessPage;
